/** @jsxImportSource @emotion/react */
import {
  DialogTitle,
  DialogContent,
  DialogFooter,
} from '@gakki/components/Dialog';
import {Dialog} from '@reach/dialog';
import Button, {ButtonGroup} from '@common/components/Button';
import React from 'react';

type DeleteDialogProps = {
  onCancel?: () => void;
  onConfirm?: () => void;
  isOpen?: boolean;
  text?: React.ReactNode;
  title?: React.ReactNode;
  content?: React.ReactNode;
  footer?: React.ReactNode;
};
export default function textDialog(props: DeleteDialogProps) {
  const {content, footer, isOpen, onCancel, onConfirm, title} = props;

  return (
    <Dialog
      isOpen={isOpen}
      style={{width: 650, paddingBottom: 0, paddingTop: 0}}
      aria-label="text-dialog"
    >
      <DialogTitle
        title={title || '全部重設'}
        onClose={onCancel}
        customStyle={{ fontWeight: 400}}
        showCloseButton
      />
      <DialogContent customStyle={{marginBottom: 0, paddingTop: 20}}>{content}</DialogContent>
      <DialogFooter customStyle={{ paddingTop: '15px'}}>
        {footer ? (
          footer
        ) : (
          <ButtonGroup>
            <Button
              variant={'cta'}
              onClick={onConfirm}
              className={'confirm-btn'}
              data-test-id={'confirm-btn'}
              aria-label={'confirm-btn'}
            >
              確定
            </Button>
          </ButtonGroup>
        )}
      </DialogFooter>
    </Dialog>
  );
}
